var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{class:_vm.$style.heading},[_vm._v("\n    We noticed you don't have a "+_vm._s(_vm.provider)+" account connected.\n  ")]),_vm._v(" "),_c('p',{class:_vm.$style.subHeading},[_vm._v("\n    The information provided does not appear to be associated with a current organization.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }